import { Plugin, Context } from '@nuxt/types';

const continuallyTrackedActivities = [
  'lastCampaignCreatedAt',
  'lastCampaignSentAt',
  'lastDesktopLoginRequest'
];

const track = async (context: Context, activity: string): Promise<void> => {
  if (
    !continuallyTrackedActivities.includes(activity) &&
    context.store.getters['user/activitiesTracked']?.[activity]
  )
    return;

  const response = await context.store.dispatch(
    'user/createActivitiesTracked',
    {
      activity: activity
    }
  );

  if (!response.success) {
    console.error({
      errors: response.errors,
      body: response.body
    });
  }
};

const activityTracking: Plugin = async (context: Context, inject) => {
  inject('activityTracking', {
    track: activity => track(context, activity)
  });
};

export default activityTracking;
